import { render } from "./colorcard.vue?vue&type=template&id=fa436718&scoped=true"
import script from "./colorcard.vue?vue&type=script&lang=js"
export * from "./colorcard.vue?vue&type=script&lang=js"

import "./colorcard.vue?vue&type=style&index=0&id=fa436718&scoped=true&lang=css"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa436718"]])

export default __exports__